import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { fetchCompetitionOverview } from "../utils/api";

const EMPTY_COMPETITION = {
  id: null,
  brandName: "",
  tagline: "",
  title: "",
  startDate: "",
  startDateFormatted: "",
  startDateLabel: "",
  endDate: "",
  endDateFormatted: "",
  endDateLabel: "",
  countdownMode: "start",
  countdownTarget: "",
  totalPrizePool: "",
  startingBalance: "",
  duration: "",
  currency: "USD",
  participateUrl: "#participate",
  howItWorksUrl: null,
  termsConditionsUrl: null,
  hasTermsConditions: false,
  extraUrl: null,
  teamId: null,
  countryEligible: true,
  ipCountry: null,
  stats: [
    { key: "duration", value: "" },
    { key: "startingBalance", value: "" },
    { key: "entry", valueKey: "entryValue", highlight: true },
    { key: "accounts", valueKey: "accountsValue" },
  ],
};

const CompetitionContext = createContext({
  competition: EMPTY_COMPETITION,
  prizes: [],
  competitionId: null,
  isLoading: true,
});

export const CompetitionProvider = ({ children }) => {
  const [state, setState] = useState({
    competition: EMPTY_COMPETITION,
    prizes: [],
    competitionId: null,
    isLoading: true,
  });

  useEffect(() => {
    let isMounted = true;

    const loadCompetition = async () => {
      try {
        const response = await fetchCompetitionOverview();
        const result = response?.payload?.result || response?.payload || {};

        if (!isMounted) return;

        setState({
          competition: result.competition || EMPTY_COMPETITION,
          prizes: Array.isArray(result.prizes) ? result.prizes : [],
          competitionId: result.competitionId || null,
          isLoading: false,
        });
      } catch {
        if (!isMounted) return;
        setState((current) => ({ ...current, isLoading: false }));
      }
    };

    loadCompetition();
    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(() => state, [state]);
  return <CompetitionContext.Provider value={value}>{children}</CompetitionContext.Provider>;
};

export const useCompetition = () => useContext(CompetitionContext);
